module.exports = __webpack_public_path__ + "img/sld_abt_check_disable.53c769a8.svg";